export const MAX_FILE_SIZE_MB = 5;
export const MAX_FILE_SIZE_BYTES = MAX_FILE_SIZE_MB * 1024 * 1024;
export const SUPPORTED_FORMATS = ['pdf', 'txt', 'json', 'png', 'jpeg', 'jpg', 'pptx', 'csv', 'xlsx'];
